import request from '@/utils/request'
import { indexTime } from '@/utils/data'
export default class Index {
  constructor (siteCode, depth) {
    // 网站编码
    this.siteCode = siteCode
    // 指数列表
    this.indexList = []
    // 指数分类层次
    this.depth = depth || 5
    // 指数结构
    this.indexStruct = []
  }

  /** 获取指数 */
  async getIndexList () {
    await getIndexList({ siteCode: this.siteCode }).then(res => {
      this.indexList = filterIndex(res.data)
    })
  }

  /** 获取指数分类 */
  async getIndexCate () {
    await this.getIndexList()
    for (let i = 0; i < this.indexList.length; i++) {
      const res = await getIndexCate(this.indexList[i].id, { depth: this.depth })
      this.indexStruct.push(filterIndexCate(res.data))
    }
  }

  /** 获取指数数据 */
  async getIndxData () {
    await this.getIndexCate()
    await this.getIndexStructData(this.indexStruct)
  }

  /** 指数数据 */
  async getIndexStructData (data) {
    for (let i = 0; i < data.length; i++) {
      const res = await getIndexData(data[i].id, {
        structCode: data[i].code
      })
      data[i].data = formatIndexData(res.data, indexTime[data[i].id])
      if (data[i].id === 540) {
        data[i].data.xData[0] = getDateForIndex(data[i].data.xData[0], 'year')
      }
      if (data[i].children) {
        await this.getIndexStructData(data[i].children)
      }
    }
  }
}

/**
 * 获取网站指数列表
 * @param {*} query
 * @returns
 */
function getIndexList (query) {
  return request({
    url: '/website/public/project',
    method: 'get',
    params: query
  })
}

/**
 * 过滤指数
 * @param {*} data
 * @returns
 */
function filterIndex (data) {
  return data.map(v => {
    return {
      name: v.project.name,
      id: v.project.id
    }
  })
}

/**
 * 获取指数分类
 * @param {*} id
 * @param {*} query
 * @returns
 */
function getIndexCate (id, query) {
  return request({
    url: `/index/project/${id}/struct`,
    params: query
  })
}

/**
 * 获取指数结构
 * @param {*} data
 * @returns
 */
function filterIndexCate (data) {
  const result = {}
  // 判断是否为数组
  if (Array.isArray(data)) {
    const list = []
    data.forEach(v => {
      list.push(v.nodes && v.nodes.length > 0 ? {
        id: v.projId,
        name: v.name,
        code: v.code,
        children: filterIndexCate(v.nodes)
      } : {
        id: v.projId,
        code: v.code,
        name: v.name,
        children: []
      })
    })
    return list
  } else {
    result.id = data.projId
    result.name = data.name
    result.code = data.code
    result.children = []
    if (data.nodes && data.nodes.length > 0) {
      result.children = filterIndexCate(data.nodes)
    }
  }

  return result
}

/**
 * 获取指数数据
 * @param {*} id
 * @param {*} query
 * @returns
 */
function getIndexData (id, query) {
  return request({
    url: `/index/project/${id}/data`,
    params: query
  })
}

function getDateForIndex (date, dateType) {
  dateType = dateType || 'month'
  var dateArray = date.split('-')
  switch (dateType) {
    case 'month':
      date = date.substring(0, 7)
      break
    case 'month-half':
      dateArray[2] = parseInt(dateArray[2])
      var half = dateArray[2] > 15 ? '下' : '上'
      date = date.substring(0, 7) + half
      break
    case 'quarter':
      dateArray[1] = parseInt(dateArray[1])
      var quarter = parseInt(dateArray[1] / 4) + 1
      date = dateArray[0] + 'Q' + quarter
      break
    case 'half':
      dateArray[1] = parseInt(dateArray[1])
      var half = dateArray[1] <= 6 ? '上' : '下'
      date = dateArray[0] + half
      break
    case 'year':
      date = dateArray[0]
      break
    default:
      date = date.substring(0, 10)
  }
  return date
}

function formatIndexData (data, dateType, compareType) {
  var xData = []; var yData = []; var gap = []; var rate = []; var y; var x; var last = []; var same = []
  compareType = compareType || 'base'
  if (compareType === 'last') {
    for (var i = 0; i < data.length; i++) {
      if (data[i].lastValue > 0) {
        y = (data[i].lastValue).toFixed(2)
        x = getDateForIndex(data[i].publishTime, dateType)
        xData.unshift(x)
        yData.unshift(y)
      }
    }
  } else if (compareType === 'same') {
    for (let i = 0; i < data.length; i++) {
      if (data[i].sameValue > 0) {
        x = getDateForIndex(data[i].publishTime, dateType)
        y = (data[i].sameValue).toFixed(2)
        xData.unshift(x)
        yData.unshift(y)
      }
    }
  } else {
    var cha, curr_rate
    for (var i = 0; i < data.length; i++) {
      y = data[i].indexValue.toFixed(2)
      if (data[i].lastValue) {
        var lasty = parseFloat((data[i + 1].indexValue).toFixed(2))
        cha = (parseFloat(y) - lasty).toFixed(2)
        curr_rate = (parseFloat(cha) / lasty * 100).toFixed(2)
      } else {
        cha = '0.00'
        curr_rate = '0.00'
      }
      x = getDateForIndex(data[i].publishTime, dateType)
      xData.unshift(x)
      yData.unshift(y)
      gap.unshift(cha)
      rate.unshift(curr_rate)
      last.unshift(data[i].lastValue.toFixed(2))
      same.unshift(data[i].sameValue.toFixed(2))
    }
  }

  return {
    xData: xData,
    yData: yData,
    gap: gap,
    rate: rate,
    last,
    same
  }
}
